export default "__VITE_ASSET__BZFi11GZ__"